import { message } from "antd";
import API from "./API";
const getAuthHeaders = () => {
  // const token = localStorage.getItem('token');
  const token = JSON.parse(localStorage.getItem('access'));
  return {
    'Authorization': token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json'
  };
};


// user login api
export const userLogin = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`login/`, fromData, {
    headers: { "Content-Type": "application/json" },
    Authorization: `Bearer ${access}`,
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const getParties = async () => {
  try {
    const response = await API.get(`party/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    message.error("Failed to fetch parties");
    return [];
  }
};

export const getPartyById = async (id) => {
  try {
    const response = await API.get(`party/${id}/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    message.error("Failed to fetch party");
    return null;
  }
};

export const createParty = async (formData) => {
  try {
    const response = await API.post(`party/`, formData, {
      headers: getAuthHeaders(),
    });
    message.success("Party created successfully");
    return response.data;
  } catch (error) {
    message.error(error.response?.data?.message || "Failed to create party");
    return null;
  }
};

export const updateParty = async (id, formData) => {
  try {
    const response = await API.put(`party/${id}/`, formData, {
      headers: getAuthHeaders(),
    });
    message.success("Party updated successfully");
    return response.data;
  } catch (error) {
    message.error("Failed to update party");
    return null;
  }
};

export const deleteParty = async (id) => {
  try {
    await API.delete(`party/${id}/`, {
      headers: getAuthHeaders(),
    });
    message.success("Party deleted successfully");
    return true;
  } catch (error) {
    message.error("Failed to delete party");
    return false;
  }
};
// Get all vehicle insurances with pagination and filters
export const getVehicleInsurances = async (filters = {}, page = 1, pageSize = 10) => {
  try {
    const params = new URLSearchParams();

    if (filters.vehicleNo) params.append('vehicleNo', filters.vehicleNo);
    if (filters.ownerName) params.append('ownerName', filters.ownerName);
    if (filters.chassisNumber) params.append('chassisNumber', filters.chassisNumber);
    if (filters.mobileNumber) params.append('mobileNumber', filters.mobileNumber);
    if (filters.expiryFilter) params.append('expiryFilter', filters.expiryFilter);

    params.append('page', page);
    params.append('page_size', pageSize);

    const response = await API.get(`/vehicle-insurances/?${params.toString()}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching vehicle insurances:', error);
    message.error(error.response?.data?.message || "Failed to fetch vehicle insurances");
    throw error;
  }
};

// Delete vehicle insurance
// export const deleteVehicleInsurance = async (id) => {
//   try {
//     const response = await API.delete(`/vehicle-insurances/${id}/`, {
//       headers: getAuthHeaders(),
//     });
//     message.success("Vehicle insurance deleted successfully");
//     return response.data;
//   } catch (error) {
//     console.error('Error deleting vehicle insurance:', error);
//     message.error(error.response?.data?.message || "Failed to delete vehicle insurance");
//     throw error;
//   }
// };

export const deleteVehicleInsurance = async (id) => {
  return await API.delete(`/insurance/${id}/`, {
    headers: getAuthHeaders(),
  });
};

export const getVehicleInsuranceById = async (id) => {
  try {
    const response = await API.get(`insurance/${id}/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    message.error("Failed to fetch vehicle insurance");
    return null;
  }
};
export const getVehicleInsurancesByParty = async (id) => {
  try {
    const response = await API.get(`party/vehicles/${id}/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    message.error("Failed to fetch vehicle insurance");
    return null;
  }
};
export const getVehicleInsuranceByVehicleNo = async (vehicleNo) => {
  try {
    const response = await API.get(`insurance/by_vehicle/?vehicleNo=${vehicleNo}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    message.error("Failed to fetch vehicle insurance");
    return null;
  }
};

export const createVehicleInsurance = async (formData) => {
  try {
    const response = await API.post(`insurance/`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });
    message.success("Vehicle insurance created successfully");
    return response.data;
  } catch (error) {
    message.error(error.response?.data?.message || "Failed to create vehicle insurance");
    return null;
  }
};

export const updateVehicleInsurance = async (id, formData) => {
  try {
    const response = await API.put(`insurance/${id}/`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });
    message.success("Vehicle insurance updated successfully");
    return response.data;
  } catch (error) {
    message.error("Failed to update vehicle insurance");
    return null;
  }
};




// bill APIs
export const createBill = async (formData) => {
  try {
    const response = await API.post(`create-bill/`, formData, { headers: getAuthHeaders() });
    message.success("Bill created successfully");
    return response.data;
  } catch (error) {
    message.error(error.response?.data?.message || "Failed to create bill");
    return null;
  }
}
// Add these functions to your existing Services.js

// Get all bills with pagination and filters
export const getBills = async (params = {}) => {
  try {
    const response = await API.get(`create-bill/`, {
      headers: getAuthHeaders(),
      params: params
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching bills:", error);
    message.error("Failed to fetch bills");
    return { results: [], next: null };
  }
};

export const getPendingBills = async (params = {}) => {
  try {
    const response = await API.get(`pending-bills/`, {
      headers: getAuthHeaders(),
      params: params
    });

    return response.data;

  } catch (error) {

    console.error("Error fetching pending bills:", error);

    message.error("Failed to fetch pending bills");

    return {
      results: [],
      next: null
    };
  }
};
// Delete a bill by ID
export const deleteBill = async (id) => {
  try {
    const response = await API.delete(`create-bill/${id}/`, {
      headers: getAuthHeaders(),
    });
    message.success("Bill deleted successfully");
    return response.data;
  } catch (error) {
    console.error("Delete bill error:", error);
    message.error(error.response?.data?.message || "Failed to delete bill");
    throw error;
  }
};

// Update a bill by ID
export const updateBill = async (id, billData) => {

  try {

    const response = await API.put(
      `create-bill/${id}/`,
      billData,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;

  } catch (error) {

    console.error("Update bill error:", error);

    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Failed to update bill";

    message.error(errorMessage);

    throw error;
  }
};  



// export const updateBill = async (id, billData) => {

//   const csrftoken = document.cookie
//     .split("; ")
//     .find(row => row.startsWith("csrftoken="))
//     ?.split("=")[1];

//   console.log("CSRF =", csrftoken);

//   return await API.put(
//     `create-bill/${id}/`,
//     billData,
//     {
//       headers: {
//         ...getAuthHeaders(),
//         "X-CSRFToken": csrftoken,
//       },
//       withCredentials: true,
//     }
//   );
// };

// Get bills by party ID
export const getBillById = async (bill_id) => {
  try {
    const response = await API.get(`create-bill/?pk_bill_id=${bill_id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching bills by party:", error);
    return { results: [] };
  }
};


// Get bills by party ID
export const getBillsByParty = async (partyId) => {
  try {
    const response = await API.get(`create-bill/?party_id=${partyId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching bills by party:", error);
    return { results: [] };
  }
};

// Create receipt
export const createReceipt = async (receiptData) => {
  try {
    const response = await API.post(`receipts/save/`, receiptData, {
      headers: getAuthHeaders(),
    });
    message.success("Receipt created successfully");
    return response.data;
  } catch (error) {
    console.error("Error creating receipt:", error);
    message.error(error.response?.data?.message || "Failed to create receipt");
    throw error;
  }
};


export const getReceipts = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const url = `receipts/${params ? `?${params}` : ''}`;
    const response = await API.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching receipts:', error);
    throw error;
  }
};

// Get single receipt by ID
export const getReceiptById = async (id) => {
  try {
    const response = await API.get(`receipts/${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching receipt:', error);
    throw error;
  }
};

// Delete receipt
export const deleteReceipt = async (id) => {
  try {
    const response = await API.delete(`receipts/${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting receipt:', error);
    throw error;
  }
};

export const updateReceipt = async (id, data) => {
  try {
    const response = await API.delete(`receipts/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating receipt:", error);
    throw error;
  }
};

// Vehicle Dashboard data APIs
export const getDashboardData = async () => {
  try {
    const response = await API.get(`dashboard/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    message.error("Failed to fetch vehicle insurances");
    return [];
  }
};


// Update a bill by ID
export const settleBillAmount = async (id, billData) => {
  try {
    const response = await API.put(`pending-bills/${id}/`, billData, {
      headers: getAuthHeaders(),
    });
    message.success("Bill updated successfully");
    return response.data;
  } catch (error) {
    console.error("Update bill error:", error);
    message.error(error.response?.data?.message || "Failed to update bill");
    throw error;
  }
};

// Expiry Analysis APIs

export const getInsuranceData = async () => {
  try {
    const response = await API.get("insurance/", {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching insurance data:", error);
    throw error;
  }
};

export const deleteInsuranceData = async (id) => {
  try {
    const response = await API.delete(`insurance/${id}/`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting insurance:", error);
    throw error;
  }
};

export const updateInsuranceData = async (id, data) => {
  try {
    const response = await API.put(
      `insurance/${id}/`,
      data,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating insurance:", error);
    throw error;
  }
};












































































































